import { InjectionToken } from '@angular/core';

import { AttachmentEndpoints } from '@core/interfaces/attachment.interface';

export const ATTACHMENTS_ENDPOINTS = new InjectionToken<AttachmentEndpoints>(
  'ATTACHMENT_ENDPOINT',
  {
    factory: () => ({
      connectedAttachments: '/rgg/email2cs/v1/emails/attachments',
      guestAttachments: '/rgg/email2cs-nc/v1/emails/attachments',
    }),
  },
);
